























import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { routes, getTitleFromRouteName } from '@/router';
import { Access } from '@/models';
import { Watch, Prop } from 'vue-property-decorator';
@Component
export default class MenuNew extends Vue {
  @Getter('modules', { namespace: 'user' }) modules: Record<string, string>;
  @Prop(Boolean) readonly value: boolean;
  get routes() {
    return routes.filter(({ root: { name } }) =>
      this.modules[name.slice(0, -4)]?.includes(Access.Read),
    );
  }
}
